import {AfterViewInit, Component, Input, OnInit} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-edit-comment',
  templateUrl: './edit-comment.component.html',
  styleUrls: ['./edit-comment.component.scss']
})
export class EditCommentComponent implements OnInit, AfterViewInit {
  @Input() commentInfo: any;
  fileImg64: any;
  wrongSize: any;
  commentForm: FormGroup;
  maxLength = 350;

  constructor(
    private fb: FormBuilder,
    private activeModal: NgbActiveModal,
  ) {
  }

  ngOnInit(): void {
    this.fileImg64 = this.commentInfo ? this.commentInfo.img : null;
    this.createForm();
  }


  ngAfterViewInit(): void {
    this.updateForm();
  }

  sendData() {
    this.commentForm.get('codeImg').setValue(Number(this.commentForm.value.codeImg));
    const dataToSend = {
      ...this.commentForm.value,
      id: this.commentInfo.id,
      img64Upload: !this.commentInfo.img64Upload? false : this.commentInfo.img64Upload,
    };

    this.activeModal.close(dataToSend);
  }

  private createForm(): any {
    this.commentForm = this.fb.group({
      title: ['', Validators.required],
      comment: ['', Validators.required],
      img: [''],
      img64: [''],
      subTitle: ['', Validators.required],
      codeImg: [1],
    });
  }

  private updateForm(): any {
    this.commentForm.get('title').setValue(this.commentInfo.title);
    this.commentForm.get('comment').setValue(this.commentInfo.information);
    this.commentForm.get('subTitle').setValue(this.commentInfo.subTitle);
    // this.commentForm.get('order').setValue(this.commentInfo.orderId);
    this.commentForm.get('img64').setValue(this.commentInfo.img);
    this.commentForm.get('codeImg').setValue(this.commentInfo.codeImg);
    this.commentInfo.img64Upload = false;
  }

  getBase64(event): void {
    const reader = new FileReader();
    reader.readAsDataURL(event.target.files[0]);
    reader.onload = () => {
      const image = new Image();
      image.src = String(reader.result);
      image.onload = () => {
        if (image.width <= 200 && image.height <= 150) {
          this.wrongSize = null;
          this.fileImg64 = image.src;
          this.commentForm.get('img').setValue((event.target.files[0]).name);
          this.commentForm.get('img64').setValue(this.fileImg64.split(',')[1]);
          this.commentInfo.img64Upload = true;
        } else {
          this.wrongSize = 'Resolución de imagen no permitida (requerida: 200px x 150px)';
          return false;
        }
      };
    };
    reader.onerror = (error) => {
    };
  }

}
